// Auto-generated file

import type { ComponentType, LazyExoticComponent } from 'react';
import { lazy } from 'react';

const SCREEN_COMPONENTS: Record<string, LazyExoticComponent<ComponentType>> = {
  'email-verification-result': lazy(
    () => import('@/screens/email-verification-result'),
  ),
  'login-id': lazy(() => import('@/screens/login-id')),
  'login-password': lazy(() => import('@/screens/login-password')),
  'mfa-begin-enroll-options': lazy(
    () => import('@/screens/mfa-begin-enroll-options'),
  ),
  'mfa-country-codes': lazy(() => import('@/screens/mfa-country-codes')),
  'mfa-email-challenge': lazy(() => import('@/screens/mfa-email-challenge')),
  'mfa-enroll-result': lazy(() => import('@/screens/mfa-enroll-result')),
  'mfa-login-options': lazy(() => import('@/screens/mfa-login-options')),
  'mfa-sms-challenge': lazy(() => import('@/screens/mfa-sms-challenge')),
  'mfa-sms-enrollment': lazy(() => import('@/screens/mfa-sms-enrollment')),
  'mfa-sms-list': lazy(() => import('@/screens/mfa-sms-list')),
  'passkey-enrollment': lazy(() => import('@/screens/passkey-enrollment')),
  'reset-password': lazy(() => import('@/screens/reset-password')),
  'reset-password-email': lazy(() => import('@/screens/reset-password-email')),
  'reset-password-error': lazy(() => import('@/screens/reset-password-error')),
  'reset-password-request': lazy(
    () => import('@/screens/reset-password-request'),
  ),
  'reset-password-success': lazy(
    () => import('@/screens/reset-password-success'),
  ),
  'signup-id': lazy(() => import('@/screens/signup-id')),
  'signup-password': lazy(() => import('@/screens/signup-password')),
};

export const getScreenComponent = (
  screenName: string | undefined,
): LazyExoticComponent<ComponentType> | null => {
  if (!screenName) {
    return null;
  }
  return SCREEN_COMPONENTS[screenName] || null;
};
